import "can-construct-super"
import Control from "can-control"

import $ from 'jquery';
window.jQuery = window.$ = $;

import HeaderBase from "@/js/controllers/header/base.js";
import NavigationBase from "@/js/controllers/navigation/base.js";
import NavigationMobile from "@/js/controllers/navigation/mobile.js";

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/js/dist/tab.js';
import 'bootstrap/js/dist/collapse.js';

import 'raleway-webfont/raleway.css';

import '@common/global.scss';
import '@common/btn.scss';
import '@common/table.scss';
import '@common/site-header.scss';
import '@common/site-navigation.scss';
import '@common/site-hyper.scss';
import '@common/site-search.scss';
import '@common/site-social.scss';
import '@common/site-footer.scss';
import '@common/site-copyrights.scss';
import '@common/site-counters.scss';
import '@common/site-search-mobile.scss';
import '@common/site-slogan-mobile.scss';

import '@common/site-header-mobile.scss';

import '@common/accordion.scss';
import '@common/faq.scss';

import '@common/forms.scss';

import '@common/top-menu.scss';
import '@common/page.scss';
import '@common/main-menu-block.scss';
import '@common/text-block.scss';
import '@common/sidebar.scss';
import '@common/news.scss';
import '@common/reviews.scss';

import '@common/panel.scss';

import '@common/popups.scss';

import '@common/swiper.scss';

//
import '@styles/style.scss';
import ButtonMakeQuestion from "@/js/controllers/button/make-question.js";
import {Fancybox} from "@fancyapps/ui";
import AccordionBase from "@/js/controllers/accordion/base.js";
import AccordionMobile from "@/js/controllers/accordion/mobile.js";


/**
 * Базовый контроллер страницы
 * @type {void | *}
 */
const BasePage = Control.extend({
    defaults: {}
}, {
    init() {
        new HeaderBase('.site-header')
        new NavigationBase('.site-navigation')
        new NavigationMobile('.site-navigation')
        new ButtonMakeQuestion('body')


        const _accordion = document.querySelector('.nav-category-accordion');
        if(_accordion) {
            new AccordionMobile(_accordion)
        }


        Fancybox.bind("[data-fancybox]", {
            on: {
                done: (fancybox) => {
                    // here `fancybox` refers to the current instance
                },
            },
        });

    }
})

export {BasePage}
